import React, {Component} from 'react'
import {withRouter} from "react-router-dom";
import {Loader} from "semantic-ui-react";
import {connect} from "react-redux";
import Grid from "semantic-ui-react/dist/commonjs/collections/Grid";
import Divider from "semantic-ui-react/dist/commonjs/elements/Divider";
import InvoiceHistory from "./invoiceHistory";
import AccountSumaryCard from "./accountSumaryCard";
import PaymentAuthorizationCard from "./paymentAuthorizationCard";
import {CustomContainer} from '../custom-common';

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        historicalInvoices: state.billing.historicalInvoices,
        accountBalance: state.billing.accountBalance,
        currentBilling: state.billing.currentBilling,
        pastDue: state.billing.pastDue,
        today: state.billing.today,
    }
};

class Overview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            error: null
        }
    }

    render() {
        const {loading} = this.state;
        const {historicalInvoices, accountBalance, switchToBillingSettings} = this.props;
        if (loading) return (
            <div style={{height: 'calc(100vh - 250px)'}}><Loader active/></div>
        )
        return (
            <>
                <Grid container stackable columns={2} style={{marginTop: 0}}>
                    <Grid.Column style={{paddingLeft: 0, paddingRight: '.5em'}}>
                        <AccountSumaryCard/>
                    </Grid.Column>
                    <Grid.Column style={{paddingLeft: 0, paddingRight: '.5em'}}>
                        <CustomContainer padded style={{minHeight: 384, display: 'flex', flexDirection: 'column'}}>
                            <PaymentAuthorizationCard accountBalance={accountBalance} switchToBillingSettings={switchToBillingSettings}/>
                        </CustomContainer>
                    </Grid.Column>
                </Grid>

                {historicalInvoices && historicalInvoices.length > 0 &&
                <div>
                    <Grid container stackable columns={1} centered>
                        <Grid.Column className={"pageContent"}>
                            <Divider hidden/>
                            <React.Fragment>
                                <InvoiceHistory/>
                            </React.Fragment>
                        </Grid.Column>
                    </Grid>
                </div>
                }
            </>
        )
    }
}

export default connect(mapStateToProps)(withRouter(Overview));